import {
  ComputedPropertiesAPI,
  computedProperty,
  PurchaseInfo,
  SB,
} from '@play-co/replicant';
import { State } from '../State';

function gelLastPurchaseData(api: ComputedPropertiesAPI): PurchaseInfo | null {
  const history = api.purchases.getPurchaseHistory();
  return history.length ? history[history.length - 1] : null;
}

export default {
  adminProfileLtv: computedProperty(
    SB.number(),
    (state: State) => state.lifetimeValue / 100,
  ),

  adminProfileCreatedAt: computedProperty(
    SB.number(),
    (state: State) => state.createdAt,
  ),

  adminProfileUpdatedAt: computedProperty(
    SB.number(),
    (state: State) => state.updatedAt,
  ),

  adminProfileFreeGems: computedProperty(
    SB.number(),
    (state: State) => state.inventory.premium.free,
  ),

  adminProfilePaidGems: computedProperty(
    SB.number(),
    (state: State) => state.inventory.premium.paid,
  ),

  adminProfilePoints: computedProperty(
    SB.number(),
    (state: State) => state.inventory.points,
  ),

  adminProfileLastPurchaseName: computedProperty(
    SB.string(),
    (state: State, api: ComputedPropertiesAPI) =>
      gelLastPurchaseData(api)?.product_id || '',
  ),

  adminProfileLastPurchaseDate: computedProperty(
    SB.int(),
    (state: State, api: ComputedPropertiesAPI) =>
      gelLastPurchaseData(api)?.purchase_time || 0,
  ),
};
